import * as React from "react";
import { EventCard } from "../../../components";
import * as RenderMethods from "./RenderMethods";
import { marketColumnsDisplay } from "../../../../../constants";
import { ContainerQuery } from "react-container-query";
import { observer } from "mobx-react";

const ContainerQueryObserver = observer(ContainerQuery);
export class Multiview extends EventCard {
    constructor(props) {
        super(props);

        this.cardTypeClass = `rj-ev-list__${this.componentPrefix}--multiview`;
        this.buttonsHolderClass = `rj-ev-list__${this.componentPrefix}__buttons-holder--multiview`;
    }

    renderEventCardDetails = RenderMethods.renderEventCardDetailsMultiview;
    renderMarkets = RenderMethods.renderMarketsMultiview;
    renderBetButtons = RenderMethods.renderBetButtonsMultiview;

    render() {
        return (
            <ContainerQueryObserver query={marketColumnsDisplay}>
                {(params) => (
                    <div className={this.setClasses(this.props)}>
                        {this.renderEventCardDetails(this.getCardDetailsParams(this.props), this.componentPrefix)}
                        {this.renderMarkets(this.props, this.buttonsHolderClass, this.componentPrefix, params)}
                        {this.renderMarketsCountLink(this.getCountLinkParams(this.props), this.componentPrefix)}
                    </div>
                )}
            </ContainerQueryObserver>)
    }
}